import { IBasketCms } from '@/types/simo/basket';
import React from 'react';

import './_confirmDeleteSubscriptionModal.scss';

interface IProps {
  onDelete: () => void;
  subscriptionType: string; //'Main' | 'Extra';
  onCancelDelete: () => void;
  basketCms: IBasketCms;
}

const ConfirmMainSubscriptionModal = (props: IProps) => {
  const { onDelete, subscriptionType, onCancelDelete, basketCms } = props;
  return (
    <div className="delete-subs-modal">
      {subscriptionType === 'Main' ? (
        <>
          <h1 className="delete-subs-modal__title">{basketCms.modalHeaderMainSubs}</h1>
          <div className="delete-subs-modal__subtitle">{basketCms.modalSubtitleMainSubs}</div>
        </>
      ) : (
        <h1 className="delete-subs-modal__title">{basketCms.modalHeaderExtraSubs}</h1>
      )}
      <button
        className="ys-button ys-button--cta delete-subs-modal__delete-button"
        onClick={onDelete}
      >
        <span className="ys-button__text">{basketCms.modalButtonDelete}</span>
      </button>
      <span className="delete-subs-modal__cancel">
        <button className="ys-button ys-button--tertiary-dark" onClick={onCancelDelete}>
          <span className="ys-button__text">{basketCms.modalButtonCancel}</span>
        </button>
      </span>
    </div>
  );
};

export default ConfirmMainSubscriptionModal;
